import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";

interface Props {
  show: server.dto.Show
}

export const ShowTitle = (props: Props) => {
  const { show } = props;

  return <div className="flex gap">
    {show.isLocked && <div><i className="icon-lock" /></div>}
    {show.validationStatus !== "validated" && <div><PhosphorWarning iconSize="large" /></div>}
    <div>{show.title}</div>
  </div>
}